import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import CloseIcon from 'mdi-react/CloseIcon';
import { partial } from '../../../util/translation/translation';

/**
 * The standard modal: white rounded card, a header with title, optional
 * subtitle and close button, then the content. Put the content in
 * `.qm-body` and the buttons in `.qm-footer` (Cancel outline, then the
 * primary action), inside the form when there is one so submit works.
 * Styles: .qm* in question.scss.
 */
const FormModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  size,
  className,
  children,
}) => {
  const s = partial('shared');
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size={size}
      contentClassName={`qm${className ? ` ${className}` : ''}`}
    >
      <div className="qm-header">
        <div>
          <h2 className="qm-header__title">{title}</h2>
          {subtitle && <p className="qm-header__subtitle">{subtitle}</p>}
        </div>
        <button
          type="button"
          className="qm-header__close"
          onClick={onClose}
          aria-label={s('close')}
        >
          <CloseIcon size={20} />
        </button>
      </div>
      {children}
    </Modal>
  );
};

FormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  size: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FormModal.defaultProps = {
  subtitle: null,
  size: undefined,
  className: '',
};

export default FormModal;
